module.exports = __webpack_public_path__ + "images/Bubbles_AppleandCherry_1.png";